module.exports = __webpack_public_path__ + "img/haleakala.359d08aa.jpg";